export default {
  outStationPrice: "OutStationPrice",
  AddOutStation: "AddOutStationPrice",
  editOutStation: "EditOutStationPrice"
};
